export const MOBILE_APP_URL =
  process.env.REACT_APP_ENV === 'development'
    ? 'https://d1f2iu2vvx6h7f.cloudfront.net/app/branding_app_dev.apk'
    : 'https://d1f2iu2vvx6h7f.cloudfront.net/app/branding_app.apk';
